import {Component, OnInit} from '@angular/core';
import {AuthService} from '@app/services/auth.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-logout-page',
    templateUrl: './logout-page.component.html',
    styleUrls: ['./logout-page.component.scss'],
    standalone: false
})
export class LogoutPageComponent implements OnInit {

    constructor(
        private authService: AuthService,
        private router: Router) {
    }

    ngOnInit() {
        const hasCompanionRedirect = !!sessionStorage.getItem('companion_registration_redirect');
        const logout$ = hasCompanionRedirect && this.authService.isKeycloakAuthenticated()
            ? this.authService.keycloakLogout({skipExternalRedirect: true})
            : this.authService.logout();

        logout$.subscribe({
            next: () => {
                this.redirectAfterLogout();
            },
            error: () => {
                this.redirectAfterLogout();
            }
        });
    }

    private redirectAfterLogout(): void {
        const companionRedirect = sessionStorage.getItem('companion_registration_redirect');
        if (companionRedirect) {
            sessionStorage.removeItem('companion_registration_redirect');
            this.router.navigateByUrl(companionRedirect);
            return;
        }
        this.router.navigateByUrl('/login');
    }
}
